<template>
  <div class="container">
    <div class="ui grid">
      <h1>Company Settings</h1>
    </div>

    <div class="ui divider"></div>

    <form class="ui form segment" @submit.prevent="settingsUpdate">
      <div class="ui grid stackable">
        <div class="row">
          <div class="eight wide column">
            <label>Company Name</label>
            <input
              type="text"
              name="CompanyName"
              placeholder="Company Name"
              v-model="companyName"
            />
          </div>
        </div>

        <div class="row">
          <div class="sixteen wide column">
            <h4 class="ui dividing header">Address</h4>
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <label>Address 1</label>
            <input
              type="text"
              name="address1"
              placeholder="Address 1"
              v-model="companyAddress1"
            />
          </div>

          <div class="eight wide column">
            <label>Address 2</label>
            <input
              type="text"
              name="address2"
              placeholder="Address 2"
              v-model="companyAddress2"
            />
          </div>
        </div>

        <div class="row">
          <div class="four wide column">
            <label>City</label>
            <input
              type="text"
              name="city"
              placeholder="City"
              v-model="companyCity"
            />
          </div>

          <div class="four wide column">
            <label>State</label>
            <div id="stateSelect" class="ui fluid search selection dropdown">
              <input
                type="hidden"
                name="state"
                v-model="companyState"
                id="state"
                @change="onStateChange"
              />
              <div class="default text">Select State</div>
              <i class="dropdown icon"></i>
              <div class="menu">
                <div
                  class="item"
                  v-for="companyState in states"
                  :key="companyState.value"
                  v-bind:data-value="companyState.value"
                >
                  {{ companyState.text }}
                </div>
              </div>
            </div>
          </div>

          <div class="four wide column">
            <label>Zip</label>
            <input
              type="text"
              name="zip"
              placeholder="Zip"
              v-model="companyZip"
            />
          </div>

          <div class="four wide column">
            <label>Country</label>
            <div id="countrySelect" class="ui fluid search selection dropdown">
              <input
                type="hidden"
                name="country"
                v-model="companyCountry"
                id="country"
                @change="onCountryChange"
              />
              <div class="default text">Select Country</div>
              <i class="dropdown icon"></i>
              <div class="menu">
                <div
                  class="item"
                  v-for="companyCountry in countries"
                  :key="companyCountry.value"
                  v-bind:data-value="companyCountry.value"
                >
                  <i :class="companyCountry.flag" class="flag"></i>
                  {{ companyCountry.text }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="sixteen wide column">
            <h4 class="ui dividing header">Information</h4>
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <label>Phone Number</label>
            <input
              type="tel"
              name="Phone"
              placeholder="(000)-000-0000"
              v-mask="'(###) ###-####'"
              v-model="companyPhone"
            />
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <label>Email Address</label>
            <input
              type="email"
              name="email"
              placeholder="smith@outerbox.com"
              v-model="companyEmail"
            />
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <label>Fax Number</label>
            <input
              type="tel"
              name="fax"
              placeholder="(000)-000-0000"
              v-mask="'(###) ###-####'"
              v-model="companyFax"
            />
          </div>
        </div>

        <div class="row">
          <div class="four wide column">
            <label for="companyLogo">
              Company Logo Path
            </label>
            <input
              type="text"
              id="companyLogo"
              name="companyLogo"
              v-model="companyLogoFileName"
            />
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <label>Site Url</label>
            <input
              type="text"
              name="companyUrl"
              placeholder="http://www.google.com"
              v-model="companyUrl"
            />
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <label>Timezone</label>
            <div id="timezoneSelect" class="ui fluid search selection dropdown">
              <input
                type="hidden"
                name="timezone"
                v-model="companyTimeZone"
                id="timezone"
                @change="ontimezoneChange"
              />
              <div class="default text">Select timezone</div>
              <i class="dropdown icon"></i>
              <div class="menu">
                <div
                  class="item"
                  v-for="timezone in timezones"
                  :key="timezone.value"
                  v-bind:data-value="timezone.value"
                >
                  {{ timezone.text }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <div class="ui buttons">
              <button class="ui positive button">Save Settings</button>
              <div class="or"></div>
              <div class="ui light button" @click="$router.go(-1)">Cancel</div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import APIService from "@/assets/js/APIService";
const apiService = new APIService();

export default {
  name: "CompanySettings",
  computed: {},
  components: {},
  data() {
    return {
      companyName: "",
      companyAddress1: "",
      companyAddress2: "",
      companyCity: "",
      companyState: "",
      companyZip: "",
      companyCountry: "",
      states: [],
      countries: [],
      companyPhone: "",
      companyEmail: "",
      companyFax: "",
      companyLogo: "",
      companyLogoFileName: "",
      companyUrl: "",
      timezones: [],
      companyTimeZone: "",
      error: false,
      customImageMaxSize: 3, // megabytes
    };
  },
  mounted() {
    this.getCountries();
    this.getStates();
    this.getTimeZones();
    this.settingsDetails();
  },
  methods: {
    uploadImage() {
      $("#companyLogo input").click();
    },
    onFile(file) {
      this.createImage(file);
      // console.log(file); // file object
    },
    onLoad(dataUri) {
      this.companyLogo = dataUri;
      // console.log(dataUri); // data-uri string
    },
    onSizeExceeded(size) {
      alert(
        `Image ${size}Mb size exceeds limits of ${this.customImageMaxSize}Mb!`
      );
    },
    // Used this codepen for image upload with vuejs
    // https://codepen.io/Atinux/pen/qOvawK/
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    createImage(file) {
      // var companyLogo = new Image();
      var reader = new FileReader();
      var vm = this;
      this.companyLogoFileName = file.name;

      reader.onload = (e) => {
        vm.companyLogo = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeImage: function() {
      this.companyLogoFileName = "";
      this.companyLogo = "";
    },
    settingsDetails() {
      apiService
        .getCompanySettings()
        .then((request) => {
          this.settingsSuccessful(request);
          if (this.companyCountry == null) {
            this.companyCountry = "US";
          }

          let _this = this;
          setTimeout(function() {
            $("#stateSelect").dropdown("set selected", _this.companyState);
            $("#countrySelect").dropdown("set selected", _this.companyCountry);
            $("#timezoneSelect").dropdown(
              "set selected",
              _this.companyTimeZone
            );
          }, 2000);
        })
        .catch((err) => this.settingsFailed(err));
    },
    settingsSuccessful(request) {
      (this.companyName = request.companyName),
        (this.companyAddress1 = request.companyAddress1),
        (this.companyAddress2 = request.companyAddress2),
        (this.companyCity = request.companyCity),
        (this.companyState = request.companyState),
        (this.companyZip = request.companyZip),
        (this.companyCountry = request.companyCountry),
        (this.companyPhone = request.companyPhone),
        (this.companyEmail = request.companyEmail),
        (this.companyFax = request.companyFax),
        (this.companyLogoFileName = request.companyLogoFileName),
        (this.companyTimeZone = request.companyTimeZone),
        (this.companyUrl = request.companyUrl);
    },
    settingsFailed(err) {
      this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
        title: err.error.response.data.title,
        autoHideDelay: 10000,
        appendToast: false,
        variant: "danger",
        solid: true,
      });
    },
    settingsUpdate() {
      apiService
        .updateCompanySettings({
          companyName: this.companyName,
          companyAddress1: this.companyAddress1,
          companyAddress2: this.companyAddress2,
          companyCity: this.companyCity,
          companyState: this.companyState,
          companyZip: this.companyZip,
          companyCountry: this.companyCountry,
          companyPhone: this.companyPhone,
          companyEmail: this.companyEmail,
          companyFax: this.companyFax,
          companyLogoFileName: this.companyLogoFileName,
          companyTimeZone: this.companyTimeZone,
          companyUrl: this.companyUrl,
          error: false,
        })
        .then((request) => {
          this.settingsSuccessful(request);
          this.$router
            .push({
              name: "Company Settings",
            })
            .catch(() => {});
        })
        .catch((err) => this.settingsFailed(err));
    },
    getStates() {
      var states = [];
      apiService.getStatesByCountry("US").then((data) => {
        for (var i = 0; i < data.length; i++) {
          var state = {
            key: data[i].code,
            value: data[i].code,
            flag: data[i].code.toLowerCase(),
            text: data[i].name,
          };
          states.push(state);
        }
        this.states = states;
      });
    },
    getCountries() {
      var countries = [];
      apiService.getCountries().then((data) => {
        for (var i = 0; i < data.length; i++) {
          var country = {
            key: data[i].code,
            value: data[i].code,
            flag: data[i].code.toLowerCase(),
            text: data[i].name,
          };
          countries.push(country);
        }
        this.countries = countries;
      });
    },
    getTimeZones() {
      apiService.getTimeZones().then((data) => {
        this.timezones = data;
      });
    },
    onStateChange(event) {
      this.companyState = event.target.value;
    },
    onCountryChange(event) {
      this.companyCountry = event.target.value;
    },
    ontimezoneChange(event) {
      this.companyTimeZone = event.target.value;
    },
  },
};
</script>

<style module></style>
